<template>
  <div class="publicMain">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
      <div class="baseTitle">基本信息</div>
      <!--  -->
      <div class="top">
        <el-row>
          <el-col :span="6">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="idCode">
              <el-input v-model="form.idCode"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item label="楼栋名称" prop="sectionName">
              <el-input v-model="form.sectionName"></el-input>
            </el-form-item>
            <el-form-item label="人员类别" prop="personType">
              <el-select v-model="form.personType" placeholder="请选择人员类别" style="width:100%">
                <el-option label="特困人员(三无、五保)" :value="0"></el-option>
                <el-option label="低保或低保边缘" :value="1"></el-option>
                <el-option label="一般老人" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div class="placehold"></div>
          </el-col>
          <el-col :span="6">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="form.sex" placeholder="请选择性别" style="width:100%">
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出生日期" prop="birthDay">
              <el-date-picker
                style="width:100%"
                v-model="form.birthDay"
                value-format="yyyy-MM-dd hh:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="年龄" prop="age">
              <el-input v-model="form.age"></el-input>
            </el-form-item>
            <el-form-item label="门牌号" prop="doorCode">
              <el-input v-model="form.doorCode"></el-input>
            </el-form-item>
            <el-form-item
              label="救助类型"
              prop="rescueType"
              v-if="form.personType==0||form.personType==1"
            >
              <el-select v-model="form.rescueType" placeholder="请选择救助类型" style="width:100%">
                <el-option label="城乡最低生活保障救助" :value="0"></el-option>
                <el-option label="特困人员供养" :value="1"></el-option>
                <el-option label="临时救助" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div class="placehold"></div>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上传附件">
              <upload
                :fileLists="fileList"
                :type="typeImg"
                @success="successImg"
                @deleteImg="deleteImg"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!--  -->
      <div class="baseTitle" style="margin-top:20px">紧急联系人</div>
      <div class="top">
        <el-row>
          <el-col :span="6">
            <el-form-item label="姓名" prop="urgentName">
              <el-input v-model="form.urgentName"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="criticalName">
              <el-input v-model="form.criticalName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div class="placehold"></div>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系电话" prop="urgentPhone">
              <el-input v-model="form.urgentPhone"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="criticalPhone">
              <el-input v-model="form.criticalPhone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div class="placehold"></div>
          </el-col>
          <el-col :span="6">
            <el-form-item label="关系" prop="urgentRelationship">
              <el-select v-model="form.urgentRelationship" placeholder="请选择关系" style="width:100%">
                <el-option label="子女" :value="0"></el-option>
                <el-option label="姐妹" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关系" prop="criticalRelationship">
              <el-select v-model="form.criticalRelationship" placeholder="请选择关系" style="width:100%">
                <el-option label="子女" :value="0"></el-option>
                <el-option label="姐妹" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div class="placehold"></div>
          </el-col>
        </el-row>
      </div>
      <div class="baseTitle" style="margin-top:20px">健康情况</div>
      <div class="top">
        <el-row>
          <el-col :span="18">
            <el-form-item label="药物过敏" prop="drugAllergy">
              <el-input v-model="form.drugAllergy"></el-input>
            </el-form-item>
            <el-form-item label="饮食禁忌">
              <el-checkbox-group v-model="form.dietTaboo">
                <el-checkbox name="dietTaboo" label="0">糖</el-checkbox>
                <el-checkbox name="dietTaboo" label="1">海鲜</el-checkbox>
                <el-checkbox name="dietTaboo" label="2">蛋类</el-checkbox>
                <el-checkbox name="dietTaboo" label="3">豆制品</el-checkbox>
                <el-checkbox name="dietTaboo" label="4">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="自理情况">
              <el-radio-group v-model="form.selfCare">
                <el-radio :label="0">较差，完全需要别人照顾</el-radio>
                <el-radio :label="1">一般，有些事情需要别人照顾</el-radio>
                <el-radio :label="2">较好，一般不需要别人照顾</el-radio>
                <el-radio :label="3">很好，还可以照顾别人</el-radio>
                <el-radio :label="4">其他</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="健康情况">
              <el-checkbox-group v-model="form.health">
                <div>
                  <el-checkbox label="0">身体健康</el-checkbox>
                  <el-checkbox label="1">高血压</el-checkbox>
                  <el-checkbox label="2">冠心病</el-checkbox>
                  <el-checkbox label="3">慢性支气管炎</el-checkbox>
                  <el-checkbox label="4">糖尿病</el-checkbox>
                  <el-checkbox label="5">类风湿</el-checkbox>
                  <el-checkbox label="6">颈椎病</el-checkbox>
                  <el-checkbox label="7">高血脂</el-checkbox>
                </div>
                <div>
                  <el-checkbox label="8">恶性肿瘤</el-checkbox>
                  <el-checkbox label="9">重性精神病</el-checkbox>
                  <el-checkbox label="10">结核病</el-checkbox>
                  <el-checkbox label="11">肝炎</el-checkbox>
                  <el-checkbox label="12">哮喘</el-checkbox>
                  <el-checkbox label="13">关节炎</el-checkbox>
                  <el-checkbox label="14">老年智力障碍</el-checkbox>
                </div>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
              <el-input v-model="form.address" @blur="transLocation"></el-input>
            </el-form-item>
            <el-form-item label>
              <div id="container" style="width:550px;height:400px;"></div>
            </el-form-item>
            <el-form-item label="备注" prop="remarks">
              <el-input v-model="form.remarks"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div class="placehold"></div>
          </el-col>
        </el-row>
      </div>
      <div class="button" >
        <div class="button-mid">
          <el-button type="primary" @click="save" v-if="$route.query.buttonType == 'compile' ">确定</el-button>
          <el-button type="info" @click="back">返回</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { oldManFileEdit, oldManFileCheck } from "../api";
import upload from "@/component/componentsP/upImg.vue";
export default {
  components: {
    upload,
  },
  props: ["query"],
  data() {
    return {
      visible: false, //dialog的标题
      //模糊查询数据
      form: {
        dietTaboo: [],
        selfCare: [],
        health: [],
      },
      fileList: [],
      typeImg: "",
      //table表格的column
      rules: {
        personType: [
          { required: true, message: "请选择人员类别", trigger: "blur" },
        ],
        rescueType: [
          { required: true, message: "请选择人员类别", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //保存按钮
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let photo = "";
          if (this.fileList && this.fileList.length > 0) {
            this.fileList.forEach((item) => {
              photo = photo + item.path + ";";
            });
          }
          this.form = Object.assign({}, this.form, {
            photo: photo,
            dietTaboo: this.fun(this.form.dietTaboo),
            health: this.fun(this.form.health),
          });
          oldManFileEdit(this.form).then((res) => {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.$router.push({
              path:'/oldManFile'
            })
          });
        }
      });
    },
    //回写数据
    getData(e) {
      oldManFileCheck({ id: e }).then((res) => {
        this.form = Object.assign({}, res.content, {
          dietTaboo: this.funTurn(res.content.dietTaboo),
          health: this.funTurn(res.content.health),
        });
        this.$nextTick(()=>{
          setTimeout(()=>{
            this.mapInit('container')
          },500)
        })
        if (res.content.photo) {
          let arr = res.content.photo.split(";");
          arr.pop();
          this.fileList = arr.map((item) => {
            return {
              path: item,
              name: item,
            };
          });
          this.typeImg = "compile";
        }
      });
    },
    //
    fun(e) {
      let str = "";
      if (e.length > 0) {
        e.forEach((item) => {
          str = str + item + ",";
        });
      }
      return str;
    },
    funTurn(e) {
      let arr = [];
      if (e && e.indexOf(",") > -1) {
        arr = e.split(",");
        arr.pop();
      }
      return arr;
    },
    //返回
    back() {
      this.$router.push({
        path: "/oldManFile",
      });
    },
    successImg(e) {
      this.fileList = e;
    },
    deleteImg(e) {
      this.fileList = e;
    },
    //根据输入地址转换经纬度并标记
    transLocation() {
      var searchKey = this.form.address;
      var map = new AMap.Map("container", {
        resizeEnable: true,
        zoom: 18,
      });
      var that = this;
      AMap.plugin("AMap.Geocoder", function () {
        var geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: "all",
        });
        var marker = new AMap.Marker();
        geocoder.getLocation(searchKey, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            var lnglat = result.geocodes[0].location;
            that.form.longitude =String(lnglat.lng)
            that.form.latitude = String(lnglat.lat);
            marker.setPosition(lnglat);
            map.add(marker);
            map.setFitView(marker);
          } else {
            that.$message({
              message: "获取坐标失败，请手动获取",
              type: "error",
            });
          }
        });
      });
      var geocoder = new AMap.Geocoder({
        city: "010", //城市设为北京，默认：“全国”
        radius: 1000, //范围，默认：500
      });
      map.on("click", function (e) {
        console.log("e", e);
        that.form.longitude =String(e.lnglat.getLng()) ;
        that.form.latitude =String( e.lnglat.getLat());
        geocoder.getAddress(
                e.lnglat.getLng() + "," + e.lnglat.getLat(),
                function (status, result) {
                  if (status === "complete" && result.regeocode) {
                    console.log("result", result);
                    var address = result.regeocode.formattedAddress;
                    // that.form.address = address;
                    that.$set(that.form, "address", address);
                  } else {
                    log.error("根据经纬度查询地址失败");
                  }
                }
        );
      });
    },
    //初始化地图插件的方法
    mapInit(containerId) {
      var map = new AMap.Map(containerId, {
        resizeEnable: true,
        zoom: 18,
      });
      if (this.form.longitude != undefined && this.form.latitude != undefined) {
        var marker = new AMap.Marker({
          position: [Number(this.form.longitude) ,Number(this.form.latitude) ],
          map: map,
        });
        map.setFitView(marker);
      } else {
        AMap.plugin("AMap.Geolocation", function () {
          //异步定位当前
          var geolocation = new AMap.Geolocation();
          map.addControl(geolocation);
        });
      }
      //定义地图坐标点击事件
      var that = this;
      var geocoder = new AMap.Geocoder({
        city: "010", //城市设为北京，默认：“全国”
        radius: 1000, //范围，默认：500
      });
      map.on("click", function (e) {
        that.form.longitude = e.lnglat.getLng();
        that.form.latitude = e.lnglat.getLat();
        geocoder.getAddress(
                e.lnglat.getLng() + "," + e.lnglat.getLat(),
                function (status, result) {
                  if (status === "complete" && result.regeocode) {
                    var address = result.regeocode.formattedAddress;
                    // that.form.address = address;
                    that.$set(that.form, "address", address);
                  } else {
                    log.error("根据经纬度查询地址失败");
                  }
                }
        );
      });
    },
  },
  created() {
    // console.log("==>", JSON.parse(this.$route.query.row));
    // this.form = JSON.parse(this.$route.query.row);
    // this.buttonType = this.$route.query.buttonType;
    if (
      this.$route.query.buttonType == "compile" ||
      this.$route.query.buttonType == "check"
    ) {
      this.getData(JSON.parse(this.$route.query.row).id);

    }
  },
};
</script>

<style lang="less" scoped>
.publicMain {
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #eef1f6;
  height: 47px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}
.childrenFileSelect {
  margin-top: 20px;
}
.table {
  margin: 20px 0px;
}
.slot {
  width: 90%;
  height: 500px;
  overflow: auto;
  margin: auto;
}
.add {
  margin: 20px 0px;
}
.icon-icon7 {
  color: #dd3020;
}
.icon-tongguos {
  color: #0d5795;
}
.baseTitle {
  background-color: rgb(242, 242, 242);
  font-weight: 700;
  color: #000;
  font-size: 14px;
  padding: 10px 0px 10px 10px;
  margin-bottom: 20px;
}
.placehold {
  width: 100%;
  height: 10px;
}
.button-mid {
  width: 300px;
  margin: 30px auto;
  display: flex;
  justify-content: space-between;
}
.pagination {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px !important;
}
.table {
  height: 500px;
  overflow: auto;
}
</style>
